export default (entity = {}) => {
    return {
        id: entity.id || undefined,
        chainId: entity.chainId,
        brandKey: entity.brandKey || '',
        languages: entity.languages || ['en', 'he'],
        orderTypes: entity.orderTypes || ['sitting', 'takeaway', 'delivery'],
        identityFields: entity.identityFields || ['name', 'phone', 'email'],
        isDisabled: entity.isDisabled || false,
        supportTableNumberField: entity.supportTableNumberField || false,
    };
};
